import { isPlatformBrowser } from '@angular/common'
import { inject, Injectable, PLATFORM_ID } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router'
import { environment } from 'environments/environment'
import { TokenStorageService } from '../service/jwt/token.storage.service'
@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	private readonly tokenStorage = inject(TokenStorageService)
	private readonly router = inject(Router)
	private readonly platformId = inject(PLATFORM_ID)
	canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
		const token = this.tokenStorage.getToken('tokenUser')
		const isLoginRoute = route.routeConfig?.path === 'login'
		if (route.queryParams['tokenUser']) {
			return true
		}
		if (!token || this.isTokenExpired(token)) {
			this.tokenStorage.clearAll()
			this.redirectToLogin()
			return false
		}
		// Token is valid
		if (isLoginRoute) {
			// User is authenticated and trying to access login, redirect to home
			return this.router.createUrlTree(['/home'])
		}
		return true
	}
	private isTokenExpired(token: string): boolean {
		try {
			const payload = JSON.parse(atob(token.split('.')[1]))
			return payload.exp * 1000 < Date.now()
		} catch {
			return true
		}
	}
	private redirectToLogin(): void {
		if (isPlatformBrowser(this.platformId)) {
			// Only redirect in actual browser, not in test environment
			const isTestEnvironment =
				(globalThis as typeof globalThis & { jasmine?: unknown }).jasmine !== undefined || (globalThis as typeof globalThis & { __karma__?: unknown }).__karma__ !== undefined
			if (!isTestEnvironment) {
				globalThis.location.href = environment.cognitoLoginUrl
			}
		}
	}
}
